<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="card rounded-5 p-3 border">
            <div class="card-body form-style">
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <label for>{{ $lang.messages.name }}</label><span style="color:#ff0000"> *</span>
                  <input name="name"
                         v-model="category.name"
                         v-validate="'required|max:300'" maxlength="300"
                         class="form-control"
                         :class="{'input': true, 'is-danger': errors.has('name') }"
                         type="text"
                         v-bind:placeholder="$lang.messages.name"/>
                  <i v-show="errors.has('name')" class="fa fa-warning"></i>
                  <span v-show="errors.has('name')" class="help is-danger">{{
                      $lang.messages.please_enter_valid_name
                    }}</span>
                </div>

                <div class="col-lg-12 mb-4">
                  <label for>{{ $lang.messages.sobat_catalog_price }}</label><span style="color:#ff0000"> *</span>
                  <input name="sobat_catalog_price"
                         v-model="category.sobat_catalog_price"
                         class="form-control"
                         :class="{'input': true, 'is-danger': errors.has('sobat_catalog_price') }"
                         type="text"
                         v-bind:placeholder="$lang.messages.sobat_catalog_price"/>
                </div>

                <div class="col-lg-12 mb-4">
                  <label for>{{ $lang.messages.sobat_catalog_description }}</label><span style="color:#ff0000"> *</span>
                  <vue-editor ref="vueEditor" v-model="category.sobat_catalog_description">
                  </vue-editor>
                </div>

                <div class="col-lg-12 mb-4">
                  <div class="row mb-4">
                    <div class="col-md-9">
                      <p class="font-16 text-grey mb-1">
                        Sobat Catalog Category Image
                        <span style="color: rgb(255, 0, 0);">*</span>
                      </p>

                      <div>
                        <vue-cropper
                          style="max-width: 512px"
                          v-if="categoryImage"
                          ref="cropper"
                          :aspectRatio="1/1"
                          :initialAspectRatio="1/1"
                          :autoCropArea="1"
                          :src="categoryImage"/>
                        <img
                          v-else
                          id="storefront-image"
                          style="max-width: 512px"
                          :src="(category && category.image_representation) ? category.image_representation : ''"
                          width="100%"
                          class="d-block"
                          alt="image thumb"/>
                        <button
                          for="storefront-image-uploader"
                          type="button"
                          style="max-width: 512px"
                          class="btn btn-primary btn-block upload-img-merge-btn">
                          {{ $lang.messages.upload_image }}
                          <input
                            ref="imageUploader"
                            name="storefront-image-uploader"
                            id="storefront-image-uploader"
                            type="file"
                            @change="loadImagePreview"
                            @click="resetImageUploader"
                            class="btn upload-img"
                            accept="image/*"/>
                        </button>

                        <div class="row mt-3" v-if="categoryImage">
                          <i class="fas fa-sync-alt fa-2x ml-2 mr-3"  style="cursor: pointer;" @click.prevent="reset"/>
                          <i class="fas fa-undo fa-2x mr-3 ml-2"  style="cursor: pointer;" @click.prevent="rotate(-90)"/>
                          <i class="fas fa-undo fa-2x fa-flip-horizontal mr-3 ml-2"  style="cursor: pointer;" @click.prevent="rotate(90)"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12 mb-4">
                  <label for>Link for Asset Guide</label><span style="color:#ff0000"> *</span>
                  <input name="asset_url"
                         v-model="category.asset_url"
                         v-validate="'required'"
                         class="form-control"
                         :class="{'input': true, 'is-danger': errors.has('asset_url') }"
                         type="text"
                         placeholder="Link for Asset Guide"/>
                </div>


                <div class="col-lg-12 mb-4">
                  <label for>Age restriction</label>
                  <input name="age_restriction"
                         v-model="category.age_restriction"
                         class="form-control"
                         type="number"
                         placeholder="Age restriction"/>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 text-right">
          <button
              type="button"
              class="btn btn-primary mr-3"
              id="save-btn"
              @click="validateForm()"
          >{{ $lang.messages.save_btn_text }}
          </button>
          <button type="button" class="btn btn-outline-primary" @click="$router.go(-1)">
            {{ $lang.messages.cancel_btn_text }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import {VueEditor} from "vue2-editor";
import VueCropper from "vue-cropperjs";

export default {
  name: "AddSobatCategory",
  data() {
    return {
      category: {
        name: "",
        sobat_catalog_price: "",
        age_restriction: null,
        sobat_catalog_description: "",
        image_representation: null,
        asset_url: null
      },
      categoryImage: null,
    };
  },
  components: {
    VueEditor,
    VueCropper,
  },
  methods: {
    reset() {
      this.$refs.cropper.reset();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    loadImagePreview(e) {
      const files = e.target.files
      let that = this
      if (files && files[0]) {
        let reader = new FileReader()
        reader.onload = e => {
          // validate ratio
          var image = new Image()
          //Set the Base64 string return from FileReader as source.
          image.src = e.target.result
          //Validate the File Height and Width.
          image.onload = function () {
            // that.storefrontImage = files[0]
            that.categoryImage = e.target.result
            $('#storefront-image').attr('src', e.target.result)
            that.$refs.cropper.replace(e.target.result);
            return true
          }
        }
        reader.readAsDataURL(files[0])
      }
    },
    resetImageUploader(e) {
      this.$refs.imageUploader.value = ''
    },
    onUploadImage() {
      let that = this
      if(!this.$refs.cropper){
        return
      }
      that.cropImg = this.$refs.cropper
          .getCroppedCanvas({
            minWidth: 256,
            minHeight: 256,
            maxWidth: 800,
            maxHeight: 800,
          }).toDataURL();
      if (this.cropImg) {
        return this.$api
          .uploadImageAPIAsPatch({
            _action: `/sobat/category/${this.category.id}/upload`,
            _file: that.cropImg
          })
          .then(res => {
            this.categoryImage = null
            return res
          })
          .catch(e => { throw e })
      }
    },
    details(id) {
      this.category = {};
      this.$api
          .getAPI({
            _action: `/sobat/category/${id}`
          })
          .then(res => {
            this.category = res;
          });
    },
    save() {
      this.category.age_restriction = this.category.age_restriction == "" ? null : this.category.age_restriction
      this.$api
          .postAPI({
            _action: "/sobat/category",
            _body: this.category,
            _buttonId: "save-btn"
          })
          .then(async res => {
            this.category = res
            await this.onUploadImage()
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });
            router.push("/settings/sobat-category");
          })
          .catch(e => {
          });
    },
    update(id) {
      this.category.age_restriction = this.category.age_restriction == "" ? null : this.category.age_restriction
      this.$api
          .patchAPI({
            _action: `/sobat/category/${id}`,
            _body: this.category,
            _buttonId: "save-btn"
          })
          .then(async res => {
            await this.onUploadImage()
            this.$notify({
              group: "foo",
              text: res.message,
              type: "success"
            });

            router.push("/settings/sobat-category");
          })
          .catch(e => {
          });
    },
    validateForm() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          if (this.$route.params.id) {
            this.update(this.$route.params.id);
          } else {
            this.save();
          }
          return;
        }
      });
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
  }
};
</script>



<style scoped lang="scss">
  .card {
    border: 1px solid #636470;
    background-color: #fff;
    border-radius: 5px;
    padding-left: 20px;
  }

  .card-tagger {
    position: absolute;
    width: 20px;
    height: 100%;
    background-color: #F2EDFD;
    left: 0;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  .card-tagger {
    cursor: grab;
  }

  .card-tagger span {
    position: absolute;
    top: 50%;
    left: 8px;
    transform: translateY(-50%) rotate(90deg);
    font-size: 20px;
    font-weight: bold;
    line-height: 1;
  }

  .card .card-footer {
    background: transparent;
    padding-left: 8px;
  }

  .card .card-title {
    color: #3F424F;
    margin-bottom: 8px;
    text-align: left;
  }

  .form-control.is-valid {
    border-color: #28b779;
  }

  .form-inline {
    flex-wrap: nowrap;

    label {
      margin-bottom: 0;
    }
  }

  .upload-img-merge-btn {
    width: 100%;
    position: relative;

    .btn.upload-img {
      width: 100%;
    }
  }

  .mobile-setting {
    margin: -24px -32px;
    padding: 16px;
    background: #fff;

    .btn {
      text-transform: capitalize;
    }

    .btn-primary {
      &:hover,
      &:focus,
      &:active {
        background-color: #412386 !important;
        border: #412386 !important;
      }
    }

    .font-20 {
      font-size: 16px;
    }

    .switch {
      label {
        &:before {
          width: 42px;
          height: 24px;
        }

        &:after {
          width: 22px;
          height: 22px;
          background-color: #fff !important;
          top: 1px;
          left: -1px;
        }
      }

      input:checked {
        + label {
          &:before {
            background-color: #412386;
          }

          &:after {
            background-color: #fff;
            left: -10px;
          }
        }
      }
    }

    .upload-img-merge-btn {
      color: #412386;
      background-color: #fff;
      margin-top: 8px;
      width: auto;
    }

    .card {
      .card-body {
        padding: 8px 12px;
      }

      .card-footer {
        padding: 0;
      }
    }

    .list-group-item {
      padding-left: 0;
      padding-right: 0;
      border-left: 0;
      border-right: 0;

      &:first-child {
        border-top: 0;
      }

      &:last-child {
        border-bottom: 0;
      }

      .btn {
        font-weight: 600;
        text-transform: uppercase;
        color: #412386;
      }

      p {
        margin-bottom: 0;
      }
    }
  }
  #table-product-catalog > tbody > tr > td,
  #table-product-catalog > thead > tr > td,
  #table-product-catalog {
    border-left: 0;
    border-right: 0;
  }
  #table-product-catalog > tbody > tr > td > button{
    font-weight: 600;
    text-transform: uppercase;
    color: #412386;
    margin-top: 0;
    margin-bottom: 0;
  }
  #table-product-catalog > tbody > tr > td{
    vertical-align: middle;
  }

</style>
